module.exports = __webpack_public_path__ + "static/images/flag.ac190bea957d05bbadac55ca4b4502d3.svg";